<template lang="pug">
  .report
    PMultiSelect(v-model="reasons" title="motivos" labelItem="description")
    PCheckbox(v-model="reportOptions.cover" label="Filtrar somente cobertura")
    .button
      PButton(
        color="success"
        size="md"
        @click="generate()"
        :loading="loading"
        :disabled="!valid || !reasons.selected.length"
      ) gerar relatório

</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reasons: {
        selected: [],
        loaded: []
      },
      reportOptions: {
        cover: false
      }
    }
  },
  async created () {
    await this.$store.dispatch('common/reasons/fetchItems', {fullReload: true})
    this.reasons.loaded = this.$store.state.common.reasons.items
    // debugger
  },
  methods: {
    async generate () {
      this.loading = true

      let result

      const params = {
        companies: [],
        reasons: this.reasons.selected.map(r => r.id),
        start_date: moment(this.reportInfo.periodData.startDate).format('DD/MM/YYYY'),
        end_date: moment(this.reportInfo.periodData.endDate).format('DD/MM/YYYY'),
        ...this.reportOptions
      }

      if (this.reportInfo.entity === 'companies') {
        params.companies = this.reportInfo.entityContent.map(i => i.id)
      }

      try {
        result = await this.$API.R32.save(params)
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;
  .button {
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
